import { Formik, Form, FieldArray } from 'formik';
import { useNavigate, Link, useParams } from 'react-router-dom';

import React, { useState, useEffect, useRef  } from 'react';
import { useSelector,useDispatch } from "react-redux";

import { api } from '../../api';
import { EditMerchantSchema } from '../../validation/ValidationSchema';
import { getAllCountries, getStateByCountry } from '../../helpers/countryState';
import { getBase64 } from '../../utils/converter';
import { getProductsList, getBrands } from '../../helpers/listsApi';
import ButtonContained from '../button';
import DropdownComp from '../dropdown';
// eslint-disable-next-line
import FleUpload from '../fileUpload/FleUpload';
import Input from '../../components/input';
import { toast } from "react-toastify";
import { setSwitchRegion  } from "../../redux/authSlice";
//row
import DynamicEditMerchantRow from '../merchantRow/editMerchantRow';
import usePasswordToggle from '../hooks/usePasswordToggle';
import Swal from "sweetalert2";
import Modal from '../modals/Modal';

const EditMerchant = props => {
    // eslint-disable-next-line
    const { userType: role } = useSelector((state) => state.auth.user);
    const region = useSelector((state) => state.auth.region);
    const [loading, setLoading] = useState(true)
    const countrydata = getAllCountries();
    const [countries] = useState(countrydata)
    const [brands, setBrands] = useState([])
    const [states, setStates] = useState([])
    const [init, setInitialize] = useState([])
    // eslint-disable-next-line
    const [isEditing, setEditing] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const fileInputRefs = useRef([]);
    const [taxLabel, setTaxLabel] = useState('Tax Number');
    const [taxType, setTaxType] = useState('Tax Type');

    const [merchent, setMerchent] = useState({})
    // eslint-disable-next-line 
    const [updateData, setUpdateData] = useState(false)
    const [PwdInputType, ToggleIcon] = usePasswordToggle();
    const { id: merchentId } = useParams(); // Rename 'id' to 'merchentId'
 
    const cdn_path =  `${process.env.REACT_APP_PREVIEW_URL}${process.env.REACT_APP_UPLOAD_PATH}`;
    

    const token = useSelector((state) => state.auth.token);

    useEffect(() => {
    dispatch(setSwitchRegion(false));

    return () => {
        dispatch(setSwitchRegion(true)); // reset when unmounting
    };
    }, [dispatch]);

     useEffect(() => {
    // eslint-disable-next-line
    if (region?.id == "1") {
      setTaxLabel('GST Number');
      setTaxType('GST');
      // eslint-disable-next-line
    } else if (region?.id == "2") {
      setTaxLabel('VAT Number');
      setTaxType('VAT');
    } else {
      setTaxLabel('Tax Number');
      setTaxType('VAT');

    }
  }, [region]);


    useEffect(() => {
        api.merchants.getMerchantsById({ merchentId: merchentId },token).then(merchent => {
            if (merchent.success === false) {
                 toast.error(merchent.message);
                 navigate('/merchants');
            }
            setMerchent(merchent.data)
        }).catch(err => {
            toast.error("Something went wrong");
        })
        // eslint-disable-next-line
    }, [merchentId,token])

    useEffect(() => {
        getBrands({},token).then(res => {
            setBrands(res);
        })
    }, [token])
    const getProductsData = (data, index) => {

        getProductsList(data,token).then(res => {
            return res;
        })
    }

    const [openModal, setOpenModal] = useState(false)
    // eslint-disable-next-line
    const [headerName, setHeaderName] = useState('')
    // eslint-disable-next-line
    const [fileName, setFileName] = useState('')

    function viewProof(headerName, fileName) {
        const fileurl = `${cdn_path}${fileName}`; 
        window.open(fileurl, '_blank');
        // const isPdf = fileName.toLowerCase().endsWith('.pdf');
        // if (isPdf) {
        // const pdfUrl = `${cdn_path}${fileName}`; 
        // window.open(pdfUrl, '_blank'); // Open in a new tab

        // }else{
        // setHeaderName(headerName);
        // setFileName(fileName);
        // setOpenModal(true);
        // }
        
    }

    function closeModalPopUp() {
        setOpenModal(false);
       
    }

 


     //doc upload data
          const [documentOptions, setDocumentOptions] = useState([]);
          useEffect(() => {
           const fetchDocumentTypes = async () => {
               try {
               const response = await api.resellerType.getDocumentTypesByRegionId(
                   { resellerRegionId: region.id },
                   null
               );
              
               if (response.success === true) {
                   setDocumentOptions(response.data);
               } else {
                   setDocumentOptions([]);
               }
               } catch (error) {
               console.error('Error fetching document types:', error);
               setDocumentOptions([]);
               }
           };
   
         
               fetchDocumentTypes();
           
           }, [token,region.id]);
           
       
            const [documents, setDocuments] = useState([
              { documentTypeId: '', fileName: null , id: null }
            ]);
            
            const handleAddDocument = () => {
              const hasIncomplete = documents.some(doc => !doc.documentTypeId || !doc.fileName);
              if (hasIncomplete) {
                toast.error('Please complete all existing document entries before adding a new one.');
                return;
              }
            
              if (documents.length < 5) {
              setDocuments([
                ...documents,
                { documentTypeId: '', fileName: null, id: null }
              ]);
              }
            };
            
            const handleRemoveDocument = async(index) => {
              const docToRemove = documents[index];
                   Swal.fire({
                   title: "Remove Document",
                   text: "Are you sure to remove?",
                   confirmButtonText: 'Yes',
                   confirmButtonColor: "#5C2E91",
                   showCancelButton: true,
                   cancelButtonText: 'Cancel'
                   }).then(async(result) => {
                       if (result.isConfirmed) {
                           if (docToRemove.id !== null) {
   
                               try {
                               const payload = { id: docToRemove.id };
                               await api.merchants.deleteDocuments(payload, token);
                               toast.success('Document deleted successfully.');
                               } catch (error) {
                               toast.error('Failed to delete document.');
                               console.error('Delete error:', error);
                               }
                           }
   
                           const updated = documents.filter((_, i) => i !== index);
                           setDocuments(updated);
                       }
                   });
         
            };
            
            const handleDocumentChange = (index, field, value) => {
              if (field === 'documentTypeId') {
              
               
                 const isDuplicate = documents.some((doc, i) => {
                   // eslint-disable-next-line
                   return doc.documentTypeId == value && i !== index;
                   });
                if (isDuplicate) {
                  toast.error('This document type is already selected.');
                  return;
                }
              }
            
            
              const newDocs = [...documents];
            
              if (field === 'file') {
   
                const file = value;

                const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
                const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB
    
                if (!allowedTypes.includes(file.type)) {
                    toast.error('Invalid file type. Only PDF, JPEG, and PNG are allowed.');
                    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                    return;
                }
    
                if (file.size > maxSizeInBytes) {
                    toast.error('File size must be less than 1MB.');
                    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                    return;
                }
            
                getBase64(file, async(base64) => {
              
                const docTypeId = newDocs[index]['documentTypeId'];
               
                  if(docTypeId !== null & docTypeId !== '' & docTypeId !== undefined){
                  try {
                       const payload = {
                       documentTypeId: docTypeId,
                       merchentId: merchentId, // make sure this is accessible in the scope
                       fileName: base64
                       };
                       const responseAddDoc = await api.merchants.addMerchantDocuments(payload, token);
                       if(responseAddDoc.success){
                       toast.success('Document uploaded successfully.');
                        fetchDocumentOptions();
                       }
                       
                      
                   } catch (error) {
                       toast.error('Failed to upload document.');
                       console.error('Upload error:', error);
                   }
                  }else{
                   toast.error('Document Type Required');
                  }
       
                });
   
                 
   
   
              } else {
                newDocs[index][field] = value;
                setDocuments(newDocs);
              }
              
              };
   
   
   
               useEffect(() => {
               
                   if (merchentId) {
                       fetchDocumentOptions();
                   }
                    // eslint-disable-next-line
                   }, [merchentId]);
   
   
                 const fetchDocumentOptions = async () => {
                       try {
                       const responseDoc = await api.merchants.getDocsByMerchantId(
                           { merchentId: merchentId },
                           token
                       );
   
                       if (responseDoc.success && Array.isArray(responseDoc.data)) {
                           
                           const mappedDocuments = responseDoc.data.map(doc => ({
                           documentTypeId: doc.documentTypeId,
                           fileName: doc.fileName,
                           id: doc.id
                           }));
   
                           setDocuments(mappedDocuments); // update your state here
                       } else {
                           setDocuments([]); // clear if empty or failed
                       }
                       } catch (error) {
                       console.error('Error fetching documents:', error);
                       setDocuments([]); // clear on error
                       }
                   };
   
   
       
       
          // doc upload end




// eslint-disable-next-line
    const handleFileChange = (name, e, setFieldValue) => {
        setEditing(true)
        setFieldValue(name, e.currentTarget.files[0])
        getBase64(e.currentTarget.files[0], res => {
            api.upload.upload(res,token).then(res => {
                setFieldValue(`${name}Base64`, res.data)
            }).catch(err => {
                setFieldValue(`${name}Base64`, {})
            })
        })
    }
    useEffect(() => {
        if (init && init.length > 0) {
            setLoading(false)
        }else{
            setLoading(false)
        }
    }, [init]);
    const getCurrentCountryValue = (value, list) => {
        const currentValue = list.find(lst => lst.value === value)
        return currentValue
    }
  // eslint-disable-next-line 
    const [firstMargin, setFirstmargin] = useState(null)

    React.useEffect(() => {
        const getBrandAccessToForm =
            brands.length && merchent.brands && merchent.brands.map(brand => {
                const brandValue = brands.find(b => b.value === brand.brandId)
                brand.brandId = brandValue
                return brand
            })
        setInitialize(getBrandAccessToForm)

    }, [merchent, brands])
    if (loading) {
        return <div> Loading... </div>
    }
    return (
              // <Modal
        //     id="trans-history"
        //     showModal={showEditMerchantModal}
        //     closeModal={closeModal}
        //     modalHeader="Edit Merchant"
        //     buttonText="SAVE">
        <Formik
            enableReinitialize
            validationSchema={EditMerchantSchema}
            initialValues={{
                merchantName: merchent.merchentName || "",
                address: merchent.merchentAddress || "",
                country: getCurrentCountryValue(merchent.merchentCountry, countries) || "",
                state: getCurrentCountryValue(merchent.merchentState, getStateByCountry(merchent.merchentCountry)) || "",
                city: merchent.merchentCity || "",
                mobileNumber: merchent.merchentMobile || "",
                phone: merchent.merchentPhone || "",
                contactPerson: merchent.merchentContactPerson || "",
                emailAddress: merchent.merchentEmail || "",
                gstNumber: merchent.merchentGstNo || "",
                uploadAdhar: merchent.merchentAadharFile || "",
                uploadPan: merchent.merchentPanFile || "",
                uploadAddress: merchent.merchentAddressFile || "",
                uploadOtherDocs: merchent.merchentOtherFile || "",
                token: merchent.merchentToken || "",
                authorizationCode: merchent.merchentAuthorization || "",
                password: merchent.password,
                uploadAdharBase64: merchent.merchentAadharFile,
                uploadPanBase64: merchent.merchentPanFile || '',
                uploadAddressBase64: merchent.merchentAddressFile || '',
                uploadOtherDocsBase64: merchent.merchentOtherFile || '',
                merchentApiAccess: merchent.merchentApiAccess || "",
                brandAccess: init,
                merchentId: merchentId,

                apiKey: merchent.merchentApiKey || "",
                resellerType: region.name || '',
                documents: [{ documentTypeId: '', fileName: null,id:null }],
                taxNumber:merchent.merchenttaxNumber || '',
                is2faEnabled: merchent?.is2faEnabled ?? true,
                ipAddress:merchent.ipAddress || "",

            }}


            onSubmit={(values, actions) => {
                const brands = [];
                const brandIds = [];
                const brandNames = [];
                // console.log(values.brandAccess)
                values.brandAccess.map(dt => {
                    const { brandId, productId, margin } = dt
                    brandIds.push(brandId.value);
                    brandNames.push(brandId.label)
                    if (Object.keys(brandId).length > 0 && productId.length > 0) {
                        const products = productId.map(pr => pr && pr.value).toString();
                        brands.push({
                            brandId: brandId.value,
                            productId: products,
                            margin: margin
                        })
                    }

                    return null;
                })
                const formBody = {
                    merchentName: values.merchantName,
                    merchentAddress: values.address,
                    merchentCountry: values.country.value || '',
                    merchentState: values.state.value || '',
                    merchentCity: values.city,
                    merchentMobile: values.mobileNumber,
                    merchentPhone: values.phone,
                    merchentContactPerson: values.contactPerson,
                    merchentEmail: values.emailAddress,
                    merchentToken: values.token || '',
                    merchentAuthorization: values.authorizationCode || '',
                    merchentBrandIds: brandIds.toString(),
                    merchentBrandNames: brandNames.toString(),
                    brands,
                    merchentApiAccess: values.merchentApiAccess,
                    merchentId: values.merchentId,
                    merchenttaxNumber:values.taxNumber,
                    merchenttaxType:taxType,
                    is2faEnabled: values.is2faEnabled,
                    ipAddress: values.ipAddress
                 
                }
                if (values.password) {
                formBody.password = values.password;
                }

                // console.log(formBody)
                api.merchants.update(formBody,token).then(res => {
                    if (res.success === false) {
                         toast.error(res.message);
                    }
                    else {
                        toast.success(res.message);
                        navigate('/merchants');

                    }
                    // closeModal()
                    setUpdateData(true)
                }).catch(err => {
                    toast.error("Something went wrong", 'error');
                    // closeModal()

                })
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {

                const handleGenerateKey = () => {
                       Swal.fire({
                            title: "Generate New Key",
                            text: "Generating a new API key will invalidate the current one. This action cannot be revert back",
                            confirmButtonText: 'Yes, generate it',
                            confirmButtonColor: "#5C2E91",
                            showCancelButton: true,
                            cancelButtonText: 'Cancel'
                          }).then(async(result) => {
                                if (result.isConfirmed) {
                                const keyData = await api.merchants.generateMerchentKey({merchentId}, token);
                                if(keyData.success){
                                const newKey = keyData.data.apiKey; // optional: random key
                                setFieldValue('apiKey', newKey); // updates Formik value
                                }
                                }
                          });

                };
                return (
                    <div className="container-fluid">
                        {/* <section className="mt-4"> */}
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">EDIT MERCHANT</h1>
                                        {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                                    </div>
                                    <div className="card card-table">
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">                                                                                                                                                        
                                                        
                                                            <Input
                                                                name="resellerType"
                                                                id="resellerType"
                                                                label="Reseller Region"
                                                                placeholder="Reseller Region"
                                                                type="text"
                                                                value={values.resellerType}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="merchantName"
                                                                id="merchantName"
                                                                placeholder="Enter merchant name"
                                                                type="text"
                                                                label="Merchant Name"
                                                                value={values.merchantName}
                                                                onChange={handleChange}
                                                                error={touched.merchantName && errors.merchantName}
                                                                errorText={errors.merchantName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="address"
                                                                name="address"
                                                                placeholder="Enter address"
                                                                type="text"
                                                                label="Address"
                                                                value={values.address}
                                                                onChange={handleChange}
                                                                error={touched.address && errors.address}
                                                                errorText={errors.address}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                  

                                                    </div>
                                                    <div className="form-row">

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="city"
                                                                name="city"
                                                                placeholder="Enter city"
                                                                type="text"
                                                                label="City"
                                                                value={values.city}
                                                                onChange={handleChange}
                                                                error={touched.city && errors.city}
                                                                errorText={errors.city}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                name="country"
                                                                id="country"
                                                                label="Country"
                                                                placeholder="Please select"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("country", selectedValue)
                                                                    setFieldValue("state", "")
                                                                    const stateList = getStateByCountry(selectedValue.value)
                                                                    setStates(stateList)
                                                                }}
                                                                value={values.country}
                                                                options={countries}
                                                                error={touched.country && errors.country}
                                                                errorText={errors.country}
                                                                disabled={isSubmitting}>
                                                            </DropdownComp>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                id="state"
                                                                name="state"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("state", selectedValue)
                                                                }}
                                                                value={values.state}
                                                                label="State"
                                                                placeholder="Please select"
                                                                options={states}
                                                                error={touched.state && errors.state}
                                                                errorText={errors.state}
                                                                disabled={isSubmitting}>
                                                            </DropdownComp>
                                                        </div>
                                                    
                                                    </div>
                                                    <div className="form-row">

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="mobileNumber"
                                                                name="mobileNumber"
                                                                placeholder="Enter mobile number"
                                                                type="number"
                                                                label=" Mobile Number"
                                                                value={values.mobileNumber}
                                                                onChange={handleChange}
                                                                error={touched.mobileNumber && errors.mobileNumber}
                                                                errorText={errors.mobileNumber}
                                                                disabled={isSubmitting} />
                                                        </div>


                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="contactPerson"
                                                                name="contactPerson"
                                                                placeholder="Enter contact person"
                                                                type="text"
                                                                label="Contact Person"
                                                                value={values.contactPerson}
                                                                onChange={handleChange}
                                                                error={touched.contactPerson && errors.contactPerson}
                                                                errorText={errors.contactPerson}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="emailAddress"
                                                                name="emailAddress"
                                                                placeholder="Email (Login Id)"
                                                                type="text"
                                                                label="Email (Login Id)"
                                                                value={values.emailAddress}
                                                                onChange={handleChange}
                                                                // error={touched.emailAddress && errors.emailAddress}
                                                                // errorText={errors.emailAddress}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                readOnly
                                                                id="apiKey"
                                                                name="apiKey"
                                                                type="text"
                                                                label="Api Key"
                                                                value={values.apiKey}
                                                                disabled={isSubmitting} />
                                                                {role === 1 && (
                                                                <button className="btn mt-3" variant="primary" type='button'  style={{ padding:'5px 11px' }} onClick={handleGenerateKey}>Generate New Key</button>
                                                                )}
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="taxNumber"
                                                                placeholder={taxLabel}
                                                                type="text"
                                                                label={taxLabel}
                                                                value={values.taxNumber}
                                                                onChange={handleChange}
                                                                id="taxNumber"                                                              
                                                                />
                                                        </div>

                                                    </div>

                                                    {/* Document Upload */}

                                                    <h1 className="section-header float-left">Document Upload</h1>

                                                   <div className="form-row">
                                             
                                                    

                                                        {documents.map((doc, index) => (
                                                        <div className="form-group col-md-12 row" key={index}>
                                                            <div className="col-md-3">
                                                            <label>Document Type</label>
                                                            <select
                                                                className="form-control"
                                                                value={doc.documentTypeId}
                                                                onChange={(e) => handleDocumentChange(index, 'documentTypeId', e.target.value)}
                                                                style={{   minWidth: "100px",
                                                                height: "35px",
                                                                padding: "5px 15px",
                                                                lineHeight: "18px",
                                                                appearance: "auto", // ensures default arrow shows in most browsers
                                                                WebkitAppearance: "auto",
                                                                MozAppearance: "auto",}}
                                                            >
                                                                <option value="">Select Document</option>
                                                                {documentOptions.map((option, idx) => (
                                                                <option key={idx} value={option.documentId}>{option.documentType}</option>
                                                                ))}
                                                            </select>

                                                                {errors.documents?.[index]?.documentTypeId && (
                                                                    <small className="text-danger">{errors.documents[index].documentTypeId}</small>
                                                                )}
                                                                </div>

                                                            {doc.id === null && (

                                                            <div className="col-md-4">
                                                            <label>Upload File</label>
                                                            <input
                                                                type="file"
                                                                className="form-control-file  rounded"
                                                                onChange={(e) => handleDocumentChange(index, 'file', e.target.files[0])}
                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                            />

                                                            {errors.documents?.[index]?.file && (
                                                                <small className="text-danger">{errors.documents[index].file}</small>
                                                            )}

                                                            
                                                            </div>

                                                             )}

                                                             <div className="col-md-2">
                                                                <button className="btn submit-btn" variant="primary" type="button" onClick={() => viewProof('Document', doc.fileName)} style={{ width: "max-content",marginTop:'30px',lineHeight:'16px' }}> View</button>
                                                            </div>

                                                            <div className="col-md-2">
                                                         
                                                        
                                                            <i className="fa fa-trash" aria-hidden="true" style={{ color: "#e60b0b", marginTop:"38px"}}  onClick={() => handleRemoveDocument(index)}></i>
                                                           
                                                        </div>
                                                        

                                                        
                                                                </div>
                                                            ))}

                                                    

                                                        <div className="form-group col-md-12">
                                                        {documents.length < 5 && (
                                                        <button type="button" className="login-btn1 btn mt-3" onClick={handleAddDocument}>
                                                            <i className="fa fa-plus" aria-hidden="true"  style={{ color: "#fff"}}></i> Add New Document
                                                        </button>
                                                        )}
                                                        </div>
                                                    
                                                    </div>
                                                    

                                                    {/* <!-- Brand Access --> */}
                                                    <h1 className="section-header float-left">Brand Access</h1>
                                                    <FieldArray
                                                        name="brandAccess"
                                                        render={helper => {
                                                            return (<div>
                                                                {values.brandAccess && values.brandAccess.length > 0 && values.brandAccess.map((baccess, index) => {
                                                                    return (<DynamicEditMerchantRow

                                                                        setFirstmargin={setFirstmargin}

                                                                        key={index}
                                                                        index={index}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        touched={touched}
                                                                        errors={errors}
                                                                        isSubmitting={isSubmitting}
                                                                        brands={brands}
                                                                        products={baccess.products}
                                                                        getProductsList={getProductsData}
                                                                        handleRemoveMerchant={() => helper.remove(index)}
                                                                    />)
                                                                })}
                                                                <button
                                                                    disabled={isSubmitting}
                                                                    type="button"
                                                                    onClick={() =>
                                                                        helper.push({ brand: '', productId: '', margin: '', products: [] })
                                                                    }
                                                                    className="btn mt-3 submit-btn"
                                                                    htmlFor="gridCheck">Add Brand
                                                                </button>
                                                            </div>)
                                                        }
                                                        }
                                                    >

                                                    </FieldArray>
                                                    <br />
                                                    <div className="form-row"><br />
                                                        <div className="form-group col-md-4">
                                                            <label htmlFor="customCheck">Access</label><br />
                                                            <div className="custom-control custom-checkbox mb-3">
                                                                <input
                                                                    checked={values.merchentApiAccess}
                                                                    disabled={isSubmitting}
                                                                    style={{ zIndex: '100' }}
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck"
                                                                    name="merchentApiAccess"
                                                                    value={values.merchentApiAccess}
                                                                    onChange={(e) => { setFieldValue('merchentApiAccess', e.currentTarget.checked) }}>
                                                                </input>
                                                                <label className="custom-control-label" htmlFor="customCheck">API Access</label>
                                                            </div>
                                                        </div>

                                                        <div className="form-group col-md-6">
                                                            <label htmlFor="ipList">Whitelist IPs</label>
                                                            <textarea
                                                                className="form-control"
                                                                id="ipAddress"
                                                                name="ipAddress"
                                                                placeholder="e.g., 192.168.1.1, 192.168.1.20"
                                                                value={values.ipAddress}
                                                                onChange={handleChange}
                                                                disabled={isSubmitting}
                                                            />
                                                           </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="token"
                                                                placeholder="Enter token"
                                                                type="text"
                                                                label="Token"
                                                                value={values.token}
                                                                onChange={handleChange}
                                                                id="token"
                                                                // error={touched.token && errors.token}
                                                                // errorText={errors.token}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="authorizationCode"
                                                                id="authorizationCode"
                                                                placeholder="Enter token"
                                                                type="text"
                                                                label="Authorization code"
                                                                value={values.authorizationCode}
                                                                onChange={handleChange}
                                                                // error={touched.authorizationCode && errors.authorizationCode}
                                                                // errorText={errors.authorizationCode}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="password"
                                                                id="password"
                                                                placeholder="Enter password"
                                                                type={PwdInputType}
                                                                label="Set Password"
                                                                value={values.password}
                                                                onChange={handleChange}
                                                                error={touched.password && errors.password}
                                                                errorText={errors.password}
                                                                disabled={isSubmitting} 
                                                                isToggle={ values.password ? true: false }
                                                                toggleIcon={ ToggleIcon }/>
                                                        </div>

                                                             <div className="form-group col-md-4">
                                                            <label htmlFor="is2faEnabled" className="d-block mb-2">
                                                                Enable 2FA
                                                            </label>
                                                            <div className="custom-control custom-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="is2faEnabled"
                                                                    name="is2faEnabled"
                                                                    checked={values.is2faEnabled}
                                                                    onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                                                    disabled={isSubmitting}
                                                                />
                                                                <label className="custom-control-label" htmlFor="is2faEnabled">
                                                                    {values.is2faEnabled ? "Enabled" : "Disabled"}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h1 className="section-header float-left">Agreement</h1>
                                                    <Link to={`/merchant-agreement/${merchentId}`} style={{ color:'blue' }}>RESELLER AGREEMENT TERMS AND CONDITIONS</Link>

                                                    <div>
                                                        <ButtonContained buttonName="Update" disabled={isSubmitting} />
                                                    </div>
                                                </Form>

                                                    {openModal && <Modal
                                                        modalHeader={headerName}
                                                        showModal={openModal}
                                                        closeModal={closeModalPopUp}
                                                    // buttonText="SAVE"
                                                    >
                                                        <img src={`${cdn_path}${fileName}`} alt="nodwin" height="100%" width="100%" />
                                                    </Modal>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </section> */}
                    </div>

                )
            }}
        </Formik >
        // </Modal>
    );
}

export default EditMerchant;